import { render, staticRenderFns } from "./CoursewareStructuralElementFeedback.vue?vue&type=template&id=53b0209a&"
import script from "./CoursewareStructuralElementFeedback.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports